import { Component, OnInit, Input } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { NgxSpinnerService } from "ngx-spinner";
import { Router, ActivatedRoute } from "@angular/router";
import { environment } from "../../../environments/environment";
import * as CryptoJS from "crypto-js";
import { SubscriptionService } from "src/app/subscription/subscription.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-content-subscription",
  templateUrl: "./content-subscription.component.html",
  styleUrls: ["./content-subscription.component.css"],
})
export class ContentSubscriptionComponent implements OnInit {
  @Input() videoDetail: any;
  constructor(
    private service: BaseService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router,
    private subscriptionService: SubscriptionService,
    private toastr: ToastrService
  ) {}
  subscriptionPlan: any = 1;
  public_id: any;
  reletedShows: any = [];
  thumbnails: any;
  loading_player = false;
  app_constant: any;
  background;
  any;
  isPlaying = false;
  navigationSubscription: any;
  shimmerStatus = {
    relatedvideo: true,
  };
  invalidError: any;
  cardReady = false;
  errorShow = false;
  extraData = {
    //name: "ajay",
  };
  encodeUrl: any;
  subscription: any;
  planArrayLimit: number = 2;
  changeIndex: any;
  ngOnInit(): void {
    this.encodeUrl = CryptoJS.AES.encrypt(
      JSON.stringify(this.router.url),
      environment.secretkey
    ).toString();
    this.app_constant = environment;
    this.navigationSubscription = this.route.params.subscribe((params) => {
      this.loading_player = false;
      this.public_id = params["public_id"];
      this.isPlaying = false;
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      window.scrollTo(0, 0);
      const index = this.videoDetail.thumbnails
        .map((el) => {
          return el.image_type;
        })
        .indexOf("landscape");
      if (index !== -1) {
        this.thumbnails = this.videoDetail.thumbnails[index].asset;
      }
    });
    this.subscriptionPlanInfo();
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }
  customOptionsvideo: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      "",
      "",
      //'<span class="icon-arrow-left"></span>',
      //'<span class="icon-arrow-left"></span>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      370: {
        items: 2,
      },
      650: {
        items: 3,
      },
      925: {
        items: 4,
      },
      1108: {
        items: 4,
      },
      1257: {
        items: 5,
      },
      1460: {
        items: 6,
      },
    },
    nav: true,
  };
  subscriptionPlanInfo() {
    this.subscriptionService.subscriptionPlanInfo().subscribe(
      (res: any) => {
        this.subscription = res.results;
      },
      (err) => {
        this.toastr.error(err.error.message, "OOPS!", {
          closeButton: true,
        });
      }
    );
  }
  viewMore(index: any) {
    this.changeIndex = index;
    this.planArrayLimit = this.subscription[
      this.changeIndex
    ].description.feature.length;
  }

  playVideo() {
    this.loading_player = true;
  }
  videoStatus(event) {
    if (event.videoStatus == "ended") {
      this.changeVideo(this.reletedShows[0]);
    }
    this.isPlaying = event.isPlaying;
  }
  changeVideo(data: any) {
    this.router.navigate(["/video-detail", data.public_id]);
  }
  favoriteVideo() {
    const id = { content_id: this.public_id };
    if (this.videoDetail.is_favorite == "no") {
      this.service.addFavorite(id).subscribe(() => {
        this.videoDetail.is_favorite = "yes";
      });
    } else {
      this.service.removeFavorite(id).subscribe(() => {
        this.videoDetail.is_favorite = "no";
      });
    }
  }
  setStripeToken() {
    this.spinner.show();
    this.errorShow = true;
    //this.model.source = token.id;
    //this.addSubscription();
  }

  goSubscription() {
    this.router.navigate(["/subscription"], {
      queryParams: { public_id: this.encodeUrl, planId: this.subscriptionPlan },
    });
  }
}
